import React from 'react';
//import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import '../styles/SecondLevelMenu.css';

const SecondLevelMenu = ({ menuLevel, secondLevelMenu, secondLevelIndex, parentItemName }) => {
    //console.log(secondLevelIndex, '-- 2 level index from 2 menu');
    const menuClassName = menuLevel >= 3 ? 'Second-level-menu  Second-level-menu-active' : 'Second-level-menu';
  
    return (
      <ul className={menuClassName}>
        {secondLevelMenu.map((menuItem, index) => {
          const itemClassName = index === secondLevelIndex ? 'Second-level-item Second-level-item-active' : 'Second-level-item';
          return <li key={menuItem} className={itemClassName}>{menuItem}</li>;
        })}
        <li className="Second-level-item Parent-name">{parentItemName}</li>
      </ul>
    );
};
  
// SecondLevelMenu.propTypes = {
//     menuLevel: PropTypes.number.isRequired,
//     secondLevelMenu: PropTypes.arrayOf(PropTypes.string).isRequired,
//     secondLevelIndex: PropTypes.number.isRequired,
//     parentItemName: PropTypes.string.isRequired,
// };

function mapStateToProps(reduxState) {
  return {
    menuLevel: reduxState.menuLevel,
    secondLevelIndex: reduxState.secondLevelIndex,
    //data: reduxState.data,
  }
}

export default connect(mapStateToProps)(SecondLevelMenu);